export default "__VITE_ASSET__a53178ec__"